import { useState } from 'react'

import InfoPanel from '@/components/common/InfoPanel/InfoPanel'
import InfoItem from '@/components/common/InfoItem/InfoItem'

import { TabsNavigation, Tab } from 'pepsico-ds'


export default function DeliveryData({storeData}) {
    const [selectedTabIndex, setSelectedTabIndex] = useState(0)
  
    const handleTabClick = index => {
      setSelectedTabIndex(index)
    }
  
    if (!storeData.deliveryData || storeData.deliveryData.length === 0) {
      return (
        <InfoPanel title="Delivery Data" isCollapsible={false} defaultOpen={false} className="mt-4 !px-0">
          <div className="px-4 py-3">No delivery data available</div>
        </InfoPanel>
      )
    }
  
    const selectedDelivery = storeData.deliveryData[selectedTabIndex]
  
    return (
      <InfoPanel title="Delivery Data" isCollapsible={false} defaultOpen={false} className="mt-4 !px-0">
        <div className="">
          <TabsNavigation isDark={true} selectedIndex={selectedTabIndex}>
            {storeData.deliveryData.map((delivery, index) => (
              <Tab
                key={delivery.localizationId || index}
                className="bg-gray-850"
                label={`Route Type ${index + 1}`}
                onClick={() => handleTabClick(index)}
              />
            ))}
          </TabsNavigation>
  
          <div className="mt-4 grid grid-cols-3 gap-y-6 px-4">
            <InfoItem label="Localization ID" value={selectedDelivery.locationId} />
            <InfoItem label="Route ID" value={selectedDelivery.routeId} />
            <InfoItem label="Route Type" value={selectedDelivery.routeType} />
  
            <InfoItem label="MOA" value={selectedDelivery.moa} />
            <InfoItem label="Delivery Service" value={selectedDelivery.deliveryService} />
            <InfoItem label="Cutoff Time" value={selectedDelivery.cutoffTime} />
  
            <InfoItem
              label="Delivery Days"
              value={selectedDelivery.deliveryDays ? selectedDelivery.deliveryDays.split(',').join(', ') : 'N/A'}
            />
          </div>
        </div>
      </InfoPanel>
    )
  }